import Vue from 'vue'
import App from "./App";
import vuetify from './plugins/vuetify';
import VueLodash from 'vue-lodash'
import lodash from 'lodash'
import http from './plugins/axios'
import gmaps from './plugins/gmaps'
import router from "./config/router";
import auth from  './plugins/auth'
import filter from './config/filter'
import AddToCalendar from 'vue-add-to-calendar';
import CountryFlag from 'vue-country-flag'
import VueCountryCode from "vue-country-code";

Vue.use(VueLodash, { name: 'custom' , lodash: lodash })
Vue.use(AddToCalendar)
Vue.use(VueCountryCode)
Vue.component('country-flag', CountryFlag)

Vue.config.productionTip = false

Vue.prototype.$MAX_INT = 2147483647

new Vue({
  el: '#app',
  http,
  router,
  auth,
  vuetify,
  gmaps,
  filter,
  render: h => h(App)
}).$mount('#app')
